<template>
  <layout-main-inner
    v-loading="loading"
    title="使用记录">
    <layout-card-wrap hasSlot>
      <template slot="form">
        <!-- <el-input
          v-model="config.vendorName"
          clearable
          placeholder="请输入商家名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input> -->
        <el-button
          type="primary"
          @click="handleCurrentChange(1)">刷新</el-button>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="标签序号"
          min-width="120"
          prop="zsTagCode"></el-table-column>
        <el-table-column
          label="委托单号"
          min-width="140"
          prop="appraisalNo"></el-table-column>
        <el-table-column
          label="使用状态"
          min-width="100"
          prop="statusName">
        </el-table-column>
        <el-table-column
          label="使用时间"
          min-width="150">
          <template slot-scope="{ row }">{{ row.firstAppraisalTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          label="过期时间"
          min-width="150">
          <template slot-scope="{ row }">{{ row.expiredTime | dateformat() }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
export default {
  name: 'AppraisalTag',
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, tagSource: 2, appraisalType: 2 }
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$$appraiseApi.getappraisalorders({ ... this.config })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.list = records.map(i => ({ ...i, statusName: i.status === 16 ? '已过期' : '已使用' }))
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
